// Role ID del admin_reseller — única fuente de verdad para determinar si es reseller
export const ADMIN_RESELLER_ROLE_ID = "Ne6pwRmFkr4bArJN47NZ";

/**
 * Determina si el usuario actual es un admin reseller basándose en su ROL,
 * no en su compañía. Un usuario puede pertenecer a la compañía reseller
 * pero tener un rol de admin regular.
 */
export function useIsReseller() {
  const userRoleId = localStorage.getItem("userRoleId") || "";
  const isReseller = userRoleId === ADMIN_RESELLER_ROLE_ID;

  return {
    isReseller,
    canEdit: isReseller,
    isDisabled: !isReseller,
    inputProps: {
      disabled: !isReseller,
      readOnly: !isReseller,
    },
    selectProps: {
      isDisabled: !isReseller,
    },
  };
}

export default useIsReseller;
